/**
 * @generated SignedSource<<5c5ec22785d8b3365fabeead8a75d4aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AffiliateAddPayoutMutation$variables = {
  amount: number;
  userId: string;
};
export type AffiliateAddPayoutMutation$data = {
  readonly addPayout: {
    readonly affiliateStats: {
      readonly payout: number;
    } | null;
    readonly payouts: ReadonlyArray<{
      readonly amount: number | null;
      readonly created: any | null;
    }>;
  };
};
export type AffiliateAddPayoutMutation = {
  response: AffiliateAddPayoutMutation$data;
  variables: AffiliateAddPayoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "amount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "amount",
    "variableName": "amount"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AffiliateStats",
  "kind": "LinkedField",
  "name": "affiliateStats",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payout",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AffiliateAddPayoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "addPayout",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "payout",
            "kind": "LinkedField",
            "name": "payouts",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AffiliateAddPayoutMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "addPayout",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "payout",
            "kind": "LinkedField",
            "name": "payouts",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2e4431a2e66c9561de39e75631dc9e7a",
    "id": null,
    "metadata": {},
    "name": "AffiliateAddPayoutMutation",
    "operationKind": "mutation",
    "text": "mutation AffiliateAddPayoutMutation(\n  $amount: Int!\n  $userId: String!\n) {\n  addPayout(amount: $amount, userId: $userId) {\n    affiliateStats {\n      payout\n    }\n    payouts {\n      amount\n      created\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9adadea927f1bb6dce0d09c724db873b";

export default node;
